import { Filters } from '../../_flux/constants/filter/filters';
import {
    generateSuggestion,
    setLabel,
    setType,
    setImprovementLabel,
    TYPE_IMPROVABLE,
    setImprovementValue
} from './suggestion';
import { getPriceOptions } from '../../_flux/helper/get_price_options';

function getSuggestionFor(filterValue, filterName, currencyIsoCode) {
    switch (filterName) {
        case Filters.PRICE_MIN:
        case Filters.PRICE_MAX:
            return getPriceSuggestionFor(parseInt(filterValue, 10), filterName, currencyIsoCode);
        default:
            return generateSuggestion(filterValue, filterName, currencyIsoCode);
    }
}

function getPriceSuggestionFor(filterValue, filterName, currencyIsoCode) {
    const isMaxPrice = filterName === Filters.PRICE_MAX;
    const options = getPriceOptions(20000000, currencyIsoCode, false, true);
    const lastOptionIndex = options.length - 1;
    const optionsSequence = isMaxPrice ? options.reverse() : options;
    let suggestion = generateSuggestion(filterValue, filterName, currencyIsoCode);

    optionsSequence.forEach((option, optionIndex) => {
        const optionValue = parseInt(option[0], 10);

        if (isMaxPrice && matchedMaxOptions(filterValue, optionValue) ||
            !isMaxPrice && matchedMinOptions(filterValue, optionValue)) {
            if (optionIndex === 0) {
                suggestion = setLabel(suggestion, '');
                return false;
            } else {
                if (suggestion.improvementValue === '') {
                    suggestion = setImprovementValue(
                        suggestion,
                        optionsSequence[optionIndex - 1][0]
                    );
                    suggestion = setType(
                        setImprovementLabel(
                            suggestion,
                            optionsSequence[optionIndex - 1][1]
                        ),
                        TYPE_IMPROVABLE
                    );
                }
                return false;
            }
        } else if (
            optionIndex === lastOptionIndex &&
            isMaxPrice && !matchedMaxOptions(filterValue, optionValue) ||
            !isMaxPrice && !matchedMinOptions(filterValue, optionValue)
        ) {
            suggestion = setImprovementValue(
                suggestion,
                optionsSequence[optionIndex][0]
            );
            suggestion = setType(
                setImprovementLabel(
                    suggestion,
                    optionsSequence[optionIndex][1]
                ),
                TYPE_IMPROVABLE
            );
            return false;
        }
    });

    return suggestion;
}

function matchedMaxOptions(filterValue, optionValue) {
    return filterValue >= optionValue;
}

function matchedMinOptions(filterValue, optionValue) {
    return filterValue <= optionValue;
}

export { getSuggestionFor };